import { lazy } from "react";
import { Route, Switch } from "react-router-dom";
import { withCompass } from "../../components/compass/withCompass";

const VideoAdsM0CategoryComparePage = withCompass(
  () => import("../../workspace/bri/video-ads-m0-category-compare/Page")
);
const VideoOnlyAdTilesPage = withCompass(
  () => import("../../workspace/bri/video-only-ad-tiles/Page")
);
const VideoOnlyAdTilesAdsOnlyPage = withCompass(
  () => import("../../workspace/bri/video-only-ad-tiles-ads/Page")
);
const VideoOnlyAdTilesWeightedSamplePage = withCompass(
  () => import("../../workspace/bri/video-only-ad-tiles-sampled/Page")
);

const BrandLivestreamPage = withCompass(
  () => import("../../pages/BrandLivestreamPage")
);
const HauntedShelfAdsPage = withCompass(
  () => import("../../pages/HauntedShelfAdsPage")
);
const PromotedBrandBannerPage = withCompass(
  () => import("../../pages/PromotedBrandBannerPage")
);
const PromotedPlacementScatterPage = withCompass(
  () => import("../../pages/PromotedPlacementScatterPage")
);
const SearchAdsExperimentsPage = withCompass(
  () => import("../../pages/SearchAdsExperimentsPage")
);
const SearchAdsGridPage = withCompass(
  () => import("../../pages/SearchAdsGridPage")
);

export function BrianSolomonRoutes() {
  return (
    <Switch>
      <Route path="/bri/haunted-shelf-ads" component={HauntedShelfAdsPage} />
      <Route
        path="/bri/promoted-brand-banner"
        component={PromotedBrandBannerPage}
      />
      <Route path="/bri/brand-livestream" component={BrandLivestreamPage} />
      <Route
        path="/bri/search-ads-experiments"
        component={SearchAdsExperimentsPage}
      />
      <Route
        path="/bri/promoted-placement-scatter"
        component={PromotedPlacementScatterPage}
      />
      <Route path="/bri/search-ads-grid" component={SearchAdsGridPage} />
      <Route
        path="/bri/video-ads-m0-category-compare"
        component={VideoAdsM0CategoryComparePage}
      />
      <Route path="/bri/video-only-ad-tiles" component={VideoOnlyAdTilesPage} />
      <Route path="/bri/video-only-ad-tiles-ads" component={VideoOnlyAdTilesAdsOnlyPage} />
      <Route path="/bri/video-only-ad-tiles-sampled" component={VideoOnlyAdTilesWeightedSamplePage} />
    </Switch>
  );
}

export const slug = "bri";
